import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MunilySelectFieldOption } from 'src/app/common-components/select-field/select-field.types';
import { MUNILY_FILTER_FIELD_SIZES, MunilyFilterFieldSize } from 'src/app/common-components/filter-fields/filter-field.types';
import { MunilyTextFieldWidthLayout } from 'src/app/common-components/text-field/text-field.types';

@Component({
  selector: 'app-filter-fields-playground',
  templateUrl: './filter-fields-playground.component.html',
  styleUrls: ['./filter-fields-playground.component.scss'],
})
export class FilterFieldsPlaygroundComponent {
  readonly sizes: MunilyFilterFieldSize[] = [...MUNILY_FILTER_FIELD_SIZES];
  readonly widthLayouts: MunilyTextFieldWidthLayout[] = ['ds', 'fill'];

  size: MunilyFilterFieldSize = 'large';
  widthLayout: MunilyTextFieldWidthLayout = 'ds';
  maxWidthCustom = '';

  textLabel = 'Buscar';
  textPlaceholder = 'Texto…';
  textControl = new FormControl('');
  textIcon = 'search';

  selectLabel = 'Estado';
  selectPlaceholder = 'Todos';
  selectControl = new FormControl('');
  /** Valor al limpiar el filter-select (coincide con opción “Todos”). */
  readonly selectEmptyValue = '';
  selectOptions: MunilySelectFieldOption[] = [
    { value: '', label: 'Todos' },
    { value: 'a', label: 'Opción A' },
    { value: 'b', label: 'Opción B' },
  ];

  requiredControl = new FormControl('', Validators.required);
}
